<div class="esc" role="dialog" aria-modal="true" aria-labelledby="esc-title">
  <div class="esc__bar"></div>
  <div class="esc__head">
    <div class="esc__icon"><mat-icon>travel_explore</mat-icon></div>
    <div>
      <h3 class="esc__title" id="esc-title">This supplier may already be on MPS</h3>
      <p class="esc__sub">Link the existing account instead of creating a second one.</p>
    </div>
  </div>

  <div class="esc__body">
    <div class="esc__row" *ngFor="let m of data.matches; trackBy: trackByMatch">
      <div class="esc__main">
        <div class="esc__name">
          Already on MPS: {{ m.companyName }}<span *ngIf="m.country">&nbsp;({{ m.country }})</span>
          <span class="esc__chip" *ngIf="m.alreadyLinked">My Suppliers</span>
        </div>
        <div class="esc__why">Matched on {{ reasonLabel(m) }}</div>
      </div>
      <button type="button" class="esc__btn" (click)="link(m)">
        <mat-icon>link</mat-icon>
        Link
      </button>
    </div>
    <p class="esc__note" *ngIf="!data.allowCreateNew">
      This e-mail address already belongs to a supplier on MPS, so a new account cannot be created with it.
    </p>
  </div>

  <div class="esc__foot">
    <ng-container *ngIf="!confirmingCreate">
      <button type="button" class="esc__btn esc__btn--ghost" (click)="cancel()">Cancel</button>
      <button type="button" class="esc__btn esc__btn--ghost" *ngIf="data.allowCreateNew" (click)="confirmingCreate = true">
        None of these - create a new supplier
      </button>
    </ng-container>
    <ng-container *ngIf="confirmingCreate">
      <span class="esc__warn"><mat-icon>warning</mat-icon>Create a second account although the company may already be on MPS?</span>
      <button type="button" class="esc__btn esc__btn--ghost" (click)="confirmingCreate = false">Cancel</button>
      <button type="button" class="esc__btn esc__btn--warn" (click)="createNew()">
        <mat-icon>person_add</mat-icon>
        Yes, create new
      </button>
    </ng-container>
  </div>
</div>
